<template>
    <div class="item o-asi okraina-block">
        <div class="name">
            {{ item.PROPS.ADDRESS }}
        </div>
        <div class="block-description description">
            {{ item.PROPS.WORKTIME }}<template v-if="item.PROPS.WORKDAYS">, {{
                item.PROPS.WORKDAYS }}</template>

        </div>

    </div>
</template>

<script>
export default {
    name: "okraina-about-shop-item",
    props: {
        item: {
            type: Object,
            default() {
                return {};
            },
        },

    },
}
</script>
<style lang="scss">
.o-asi {
    .name {
        font-size: 14px !important;
        font-weight: 600;
        color: var(--color-text-title);
        margin-bottom: 5px;
    }
}
</style>